/* Actions */
export const POST_REQUEST = "POST_REQUEST";

/* Mutations */
export const CLEAR_PENDING_REQUESTS = "CLEAR_PENDING_REQUESTS";
export const ADD_PENDING_REQUEST = "ADD_PENDING_REQUEST";
